import React from 'react'
import { 
    Button, 
    Row, 
    Input, 
} from 'antd'
import { firestore } from '../../../service/firebase'
import './LearnMore.scss'

const { TextArea } = Input


export default class LearnMore extends React.Component {

    state = {
        content: '',
    }

    /*--------------------------------------------------------------*/
    /* Constructor */
    /*--------------------------------------------------------------*/

    constructor(props) {
        super(props)
        this.loadEvents()
    }


    /*--------------------------------------------------------------*/
    /* Load data */
    /*--------------------------------------------------------------*/

    loadEvents() {

        firestore.collection('LearnMore').doc('learn')
        .get()
        .then(snapshot => {

            let data = snapshot.data()
            console.log(data)
            if(data) {
                let { learn } = data
                this.setState({content: learn})    
            }
        })
    
    }


    /*--------------------------------------------------------------*/
    /* Handle Functions */
    /*--------------------------------------------------------------*/

    updateData() {
        let { content } = this.state
        let object = {
            learn: content
        }

        console.log("Data", object)

        let ref = firestore.collection('LearnMore').doc('learn')
        ref.set(object)
    }
    
    handleChange(key, value) {
        let state = this.state
        state[key] = value
        this.setState(state)
    }


    /*--------------------------------------------------------------*/
    /* Render Functions */
    /*--------------------------------------------------------------*/
   
    render() {

        return (
            <div className="learn">

                <div className="history">
                    <div className="title">Learn More</div>

                    <div style={{flex: 1, marginTop: 32}}>

                        <Row className="input-row">
                            <div className="input-label">Content</div>
                            <TextArea autosize={{minRows: 3, maxRows: 18}} 
                                value={this.state.content} 
                                onChange={evt => this.handleChange('content', evt.target.value)} />
                        </Row>

                        <Row style={{textAlign: 'right', padding: 10}}>
                            <Button type="primary" icon="save" onClick={() => this.updateData()}>Update</Button>
                        </Row>
                    </div>
                </div>

            </div>
        )
    }
}
